import { useRef, useEffect, useMemo } from 'react'
import moment from 'moment'
import queryString from 'query-string'

export const getTime = (startDate, endDate) =>{
	if (startDate && moment(startDate).isValid() && parseInt(moment(startDate).format('H'))) {
		return moment(startDate).format('HH:mm')
	}
	return null
}

export const formatDate = (startDate, endDate) => {
	if(!moment(startDate).isValid()) {
		return null
	} else if(!endDate || !moment(endDate).isValid()) {
		return moment(startDate).format('D MMMM YYYY')
	} else if (moment(startDate) * 1 === moment(endDate) * 1) {
		return moment(startDate).format('D MMMM YYYY')
	} else if (moment(startDate).format('M') === moment(endDate).format('M') && moment(startDate).format('YYYY') === moment(endDate).format('YYYY')) {
		return moment(startDate).format('D') + ' - ' + moment(endDate).format('D MMMM YYYY')
	} else if (moment(startDate).format('YYYY') === moment(endDate).format('YYYY')) {
		return moment(startDate).format('D MMMM') + ' - ' + moment(endDate).format('D MMMM YYYY')
	} else {
		return moment(startDate).format('D MMMM YYYY') + ' - ' + moment(endDate).format('D MMMM YYYY')
	}
}

export const formatTagFilterDate = (startDate, endDate) => {
	return formatDate(startDate, endDate) + (!endDate ? ' - ...' : '')
}

export const checkToday = (startDate, endDate) => {
	return (moment(startDate).format('L') === moment().format('L') && !endDate)
			|| (moment(startDate).format('L') === moment().format('L') && moment(endDate).format('L') === moment().format('L'))
}

export const serialize = (state) => {
	if (typeof state !== 'object') return
	return Object.keys(state).reduce((obj, key) => {
		if (state[key] instanceof Date) {
			obj[key] = moment(state[key]).format('YYYY-MM-DD');
		} else if (state[key] instanceof Array && state[key].length) {
			obj[key] = state[key]
		} else if (typeof state[key] === "string" && state[key] !== '') {
			obj[key] = state[key];
		} else if (typeof state[key] === "number") {
			obj[key] = state[key];
		}
		return obj;
	}, {})
}

export const getSearchParams = (name) => {
	const search = queryString.parse(window.location.search, {arrayFormat: 'bracket', parseNumbers: true})
	if (name === 'fd' || name === 'td') {
		return moment(search[name], 'YYYYMMDD').isValid() ? new Date(moment(search[name], 'YYYYMMDD').format('YYYY-MM-DD')) : null
	}
	return search[name]
}

export const setSearchParams = (state) =>{
	return queryString.stringify({
		q: state['q'],
		list_ids_arr: state['list_ids_arr']
	}, {
		arrayFormat: 'bracket'
	})
}

export const declensionWords = (n, text_forms) =>{
	n = Math.abs(n) % 100;
	let n1 = n % 10;
	if (n > 10 && n < 20) { return text_forms[2] }
	if (n1 > 1 && n1 < 5) { return text_forms[1] }
	if (n1 === 1) { return text_forms[0] }
	return text_forms[2];
}

export const useDidUpdate = (callback, deps) => {
	const hasMount = useRef(false)

	useEffect(() => {
		if (hasMount.current) {
			callback()
		} else {
			hasMount.current = true
		}
	}, deps)
}

export const useDidMount = (callback) => {
	const hasMount = useRef(false)

	useEffect(() => {
		if (!hasMount.current) {
			callback()
			hasMount.current = true
		}
	})
}

export const getCookie = (name) => {
	let matches = document.cookie.match(new RegExp(
		"(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
	));
	return matches ? decodeURIComponent(matches[1]) : undefined;
}

export const setCookie = (cookieName, value, msToExpire, path, domain, secure) => {
	let expiryDate;

	if (msToExpire) {
		expiryDate = new Date();
		expiryDate.setTime(expiryDate.getTime() + msToExpire);
	}

	document.cookie = cookieName + '=' + value +
		(msToExpire ? ';expires=' + expiryDate.toGMTString() : '') +
		';path=' + (path || '/') +
		(domain ? ';domain=' + domain : '') +
		(secure ? ';secure' : '');
}

export const removeCookie = (cookieName) => {
	document.cookie = cookieName + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
}

export const scrollTo = (element, to, duration) => {
	let start = 0,
		change = to - start,
		currentTime = 0,
		increment = 20;

	let animateScroll = function(){
		let easeInOutQuad = function (t, b, c, d) {
			t /= d/2;
			if (t < 1) return c/2*t*t + b;
			t--;
			return -c/2 * (t*(t-2) - 1) + b;
		};
		currentTime += increment;
		let val = easeInOutQuad(currentTime, start, change, duration);
		element.scroll(0, val);
		if(currentTime < duration) {
			setTimeout(animateScroll, increment);
		}
	};
	animateScroll();
}